import { parseAnyDef } from "./any.js";

//#region src/utils/zod-to-json-schema/parsers/unknown.ts
function parseUnknownDef(refs) {
	return parseAnyDef(refs);
}

//#endregion
export { parseUnknownDef };
//# sourceMappingURL=unknown.js.map